import { render, staticRenderFns } from "./JuridicoProcessoPrincipal.vue?vue&type=template&id=7ad1d75c&"
import script from "./JuridicoProcessoPrincipal.vue?vue&type=script&lang=js&"
export * from "./JuridicoProcessoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./JuridicoProcessoPrincipal.vue?vue&type=style&index=0&id=7ad1d75c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports